import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useT } from '@/lib/i18n';

export function RouteError() {
  const t = useT();
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error ?? '');
  const isChunkError = message.includes(
    'Failed to fetch dynamically imported module',
  );

  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-heritage-50 px-4">
      <div className="card max-w-lg space-y-3 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-2xl text-amber-700">
          !
        </div>
        <h1 className="text-xl font-semibold">
          {t('Не удалось загрузить часть приложения')}
        </h1>
        <p className="text-sm text-heritage-600">
          {isChunkError
            ? t(
                'Похоже, приложение обновилось, а часть файлов ещё старая. Обновите страницу или переустановите приложение.',
              )
            : t('Попробуйте обновить страницу. Если ошибка повторяется, переустановите приложение.')}
        </p>
        {message && (
          <details className="rounded-xl bg-heritage-50 p-3 text-left">
            <summary className="cursor-pointer text-xs text-heritage-500">
              {t('Технические детали')}
            </summary>
            <p className="mt-1 break-all text-[11px] text-heritage-500">
              {message}
            </p>
          </details>
        )}
        <div className="flex flex-wrap justify-center gap-2">
          <button
            type="button"
            onClick={() => {
              sessionStorage.removeItem('family-pco-chunk-reload');
              window.location.reload();
            }}
            className="btn-primary"
          >
            {t('Обновить')}
          </button>
          <Link to="/" className="btn-secondary">
            {t('На главную')}
          </Link>
        </div>
      </div>
    </main>
  );
}
